import * as PropertyBucket from '../../Properties/Properties';
import * as httpService from '../../Components/HttpService/HttpService';

export function getControlsRequested() {
    return {
        type: 'GET_CONTROLS_REQUESTED'
    };
}

export function getPlannedControlsRequested() {
    return {
        type: 'GET_PLANNED_CONTROLS_REQUESTED'
    };
}

export function getActiveControlsRequested() {
    return {
        type: 'GET_ACTIVE_CONTROLS_REQUESTED'
    };
}

export function getDoneControlsRequested() {
    return {
        type: 'GET_DONE_CONTROLS_REQUESTED'
    };
}

export function getManageDoneControlsRequested() {
    return {
        type: 'GET_MANAGE_DONE_CONTROLS_REQUESTED'
    };
}

export function getManagePlannedControlsRequested() {
    return {
        type: 'GET_MANAGE_PLANNED_CONTROLS_REQUESTED'
    };
}

export function getManageActiveControlsRequested() {
    return {
        type: 'GET_MANAGE_ACTIVE_CONTROLS_REQUESTED'
    };
}

export function getControlsDone(data) {
    return {
        type: 'GET_CONTROLS_DONE',
        payload: data
    };
}

export function getPlannedControlsDone(data) {
    return {
        type: 'GET_PLANNED_CONTROLS_DONE',
        payload: data
    };
}

export function getActiveControlsDone(data) {
    return {
        type: 'GET_ACTIVE_CONTROLS_DONE',
        payload: data
    };
}

export function getDoneControlsDone(data) {
    return {
        type: 'GET_DONE_CONTROLS_DONE',
        payload: data
    };
}

export function getManagePlannedControlsDone(data) {
    return {
        type: 'GET_MANAGE_PLANNED_CONTROLS_DONE',
        payload: data
    };
}

export function getManageActiveControlsDone(data) {
    return {
        type: 'GET_MANAGE_ACTIVE_CONTROLS_DONE',
        payload: data
    };
}

export function getManageDoneControlsDone(data) {
    return {
        type: 'GET_MANAGE_DONE_CONTROLS_DONE',
        payload: data
    };
}

export function getControlsFailed(error) {
    return {
        type: 'GET_CONTROLS_FAILED',
        payload: error
    };
}

export function getControlData(url, page, pageParam, filterParam, sortParam, programSearch, quickSearch, tablePageSize, completedParam, successCallback, mode) {
    if(pageParam !== undefined) {
		url += "&page=" + pageParam;
	}else if (isNaN(page)) {
		url += "&page=" + 0;
	} else {
		url += "&page=" + page
	}
	url += "&size=" + (tablePageSize ? tablePageSize : '10')
	if(filterParam) {
		url += "&" + filterParam
	}
	if(programSearch && programSearch.length > 0) {
		programSearch?.filter(p => typeof p === 'object' && Boolean(p)).forEach(el => {
			url += "&programSearch=" + el?.code
		})
	}
	if(quickSearch) {
		url += "&quickSearch=" + quickSearch
	}
	if(sortParam && sortParam[0] != '') {
		url += "&sortBy=" + sortParam[0] + "&sortOrder=" + sortParam[1]
	}else {
		url += "&sortBy=controlStatusChangeDate&sortOrder=asc"
	}
    if(completedParam !== undefined) {
        url += `&completed=${completedParam ? 'true' : 'false'}`
    }
    return dispatch => {

        const modeActionMap = {
            done: getDoneControlsRequested,
            planned: getPlannedControlsRequested,
            active: getActiveControlsRequested,
            manageDone: getManageDoneControlsRequested,
            managePlanned: getManagePlannedControlsRequested,
            manageActive: getManageActiveControlsRequested
        };

        const preAction = modeActionMap[mode] || getControlsRequested;
        dispatch(preAction());

        let response = httpService.getService(url, "GET");
            response.then(data => {
                
                const modeActionMap = {
                    done: getDoneControlsDone,
                    planned: getPlannedControlsDone,
                    active: getActiveControlsDone,
                    manageDone: getManageDoneControlsDone,
                    managePlanned: getManagePlannedControlsDone,
                    manageActive: getManageActiveControlsDone
                };

                const action = modeActionMap[mode] || getControlsDone;
                dispatch(action(data));

                if (successCallback) {
                    successCallback(data);
                }
            })
            .catch(error => {
                dispatch(getControlsFailed(error));
            })
    }
}

export function getSingleControlData(controlId) {
    let url = PropertyBucket.getControlById(controlId);
    return dispatch => {
        dispatch(getControlsRequested());
        fetch(url)
            .then(response => response.json())
            .then(data => {
                dispatch(getControlsDone(data));
            })
            .catch(error => {
                dispatch(getControlsFailed(error));
            })
    }
}

export function setFiltersData(filters) {
    return {
        type: SET_FILTERS_DATA,
        payload: filters,
    }
};

export function setQuickSearchData(quickSearch) {
    return {
        type: SET_QUICK_SEARCH_DATA,
        payload: quickSearch,
    }
};

export function setTabData(tab) {
    return {
        type: SET_TAB_DATA,
        payload: tab,
    }
};

export const GET_CONTROLS_DATA_REQUESTED = 'GET_CONTROLS_REQUESTED';
export const GET_PLANNED_CONTROLS_DATA_REQUESTED = 'GET_PLANNED_CONTROLS_REQUESTED';
export const GET_ACTIVE_CONTROLS_DATA_REQUESTED = 'GET_ACTIVE_CONTROLS_REQUESTED';
export const GET_DONE_CONTROLS_DATA_REQUESTED = 'GET_DONE_CONTROLS_REQUESTED';
export const GET_MANAGE_DONE_CONTROLS_DATA_REQUESTED = 'GET_MANAGE_DONE_CONTROLS_REQUESTED';
export const GET_MANAGE_PLANNED_CONTROLS_DATA_REQUESTED = 'GET_MANAGE_PLANNED_CONTROLS_REQUESTED';
export const GET_MANAGE_ACTIVE_CONTROLS_DATA_REQUESTED = 'GET_MANAGE_ACTIVE_CONTROLS_REQUESTED';
export const GET_CONTROLS_DATA_DONE = 'GET_CONTROLS_DONE';
export const GET_PLANNED_CONTROLS_DATA_DONE = 'GET_PLANNED_CONTROLS_DONE';
export const GET_ACTIVE_CONTROLS_DATA_DONE = 'GET_ACTIVE_CONTROLS_DONE';
export const GET_DONE_CONTROLS_DATA_DONE = 'GET_DONE_CONTROLS_DONE';
export const GET_MANAGE_DONE_CONTROLS_DATA_DONE = 'GET_MANAGE_DONE_CONTROLS_DONE';
export const GET_MANAGE_PLANNED_CONTROLS_DATA_DONE = 'GET_MANAGE_PLANNED_CONTROLS_DONE';
export const GET_MANAGE_ACTIVE_CONTROLS_DATA_DONE = 'GET_MANAGE_ACTIVE_CONTROLS_DONE';
export const GET_CONTROLS_DATA_FAILED = 'GET_CONTROLS_FAILED';
export const SET_FILTERS_DATA = 'SET_FILTERS_DATA';
export const SET_QUICK_SEARCH_DATA = 'SET_QUICK_SEARCH_DATA';
export const SET_TAB_DATA = 'SET_TAB_DATA';
